import "element-plus/dist/index.css";
import "./styles/globals.css";
import "./styles/sidebar.css";
import "./styles/customer.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router } from "./router";
import { i18n } from "./i18n";
import { clearCustomerToken, onAuthFailed } from "./api/http";

const app = createApp(App);
app.use(createPinia());
app.use(i18n);
app.use(router);

// 401 handler — must distinguish customer flow from staff flow. Customers
// (LIFF / PIN scope) MUST NEVER land on /login (staff page); they bounce
// back to their contract-specific /register/<key> so they can re-PIN.
// Staff stay on /login as before.
onAuthFailed(() => {
  const path =
    (typeof window !== "undefined" && window.location.pathname) || "";
  const inCustomerFlow =
    path.startsWith("/customer") || path.startsWith("/register");
  if (inCustomerFlow) {
    clearCustomerToken();
    const lastKey = (() => {
      try {
        return sessionStorage.getItem("register:lastContractKey");
      } catch {
        return null;
      }
    })();
    if (lastKey) {
      router.replace({
        name: "customer-register",
        params: { contractKey: lastKey },
      });
    } else {
      // No remembered contract — bail to a neutral page rather than /login.
      router.replace({ name: "not-found" });
    }
    return;
  }
  router.replace({ name: "login" });
});

// Dynamic import / chunk loading errors are handled by router.onError in src/router/index.ts
// which correctly redirects to the target route (to.fullPath) with cache-busting
// instead of reloading the current pathname.

app.mount("#app");
